<mat-card>
  <mat-card-header>
    <mat-card-title>Faturas</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-tab-group>
      <mat-tab label="Buscar"> <mti-buscar-faturas></mti-buscar-faturas> </mat-tab>
      <mat-tab label="Gerar Faturas"> <mti-gerar-faturas></mti-gerar-faturas></mat-tab>
    </mat-tab-group>
  </mat-card-content>
</mat-card>
